import { render } from "./AppColorCard.vue?vue&type=template&id=d2a795ac&scoped=true&ts=true"
import script from "./AppColorCard.vue?vue&type=script&lang=ts"
export * from "./AppColorCard.vue?vue&type=script&lang=ts"

import "./AppColorCard.vue?vue&type=style&index=0&id=d2a795ac&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a795ac"]])

export default __exports__